import React from 'react'
import { setModal } from "../../redux/modalSlice"
import { useDispatch, useSelector } from 'react-redux'
import { selectDropdownOptions } from '../../redux/dropdownSlice'
import { selectUser } from '../../redux/userSlice'

export default function testDataModal() {
  const modal = useSelector((state) => state.modal)
  const dispatch = useDispatch()
  const dropdownOptions = useSelector(selectDropdownOptions);
  const active = useSelector(selectUser)

  const getRoleBasedRouting = () => {
    let baseName = 'customer'
    const customerPage = dropdownOptions.find((x) => x?.id === active?.data?.customer_page_dropdown_option_id)?.code_key
    if (customerPage == 'customer_page_detail_view') {
      baseName = 'customer'
    } else if (customerPage == 'customer_page_verifications') {
      baseName = 'manual_verification'
    } else if (customerPage == 'customer_page_payment_schedule') {
      baseName = 'payment_schedule'
    }

    let route = `/${baseName}/${modal.options.customer_id}`;

    return route;
  }

  return modal.is_active && modal.type === 'test_data_modal' ? (
    <div className="modal is-active" data-testid="test-data-modal">
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="box">
          <h3 className="title is-size-4">Success</h3>
          <p className="has-text-dark my-5">
            {modal.content}{' '}
            <a href={getRoleBasedRouting()} data-testid="test-data-modal-customer-link">{modal.options.customer_name}</a>
          </p>
          <div className="field is-grouped is-flex is-justify-content-flex-end">
            <div className="buttons">
              <button data-testid="test-data-modal-ok" className="button is-light" onClick={() => dispatch(setModal({ is_active: false }))}>
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : ''
}
